import { useEffect } from 'react';
import { Burger } from '@/shared/ui/Burger';
import { classNames } from '@/shared/lib/classNames/classNames';
import { useSideMenuStore } from '../../model/store/useSideMenuStore';
import cls from './SideMenuButton.module.scss';

interface SideMenuButtonProps {
    className?: string;
}

export const SideMenuButton = (props: SideMenuButtonProps) => {
    const { className } = props;

    const { burgerClicked, isSideMenuActive, setBurgerClicked, setSideMenuValue, toggleSideMenu, toggleBurgerClicked } =
        useSideMenuStore();
    // Use useEffect to add or remove the overflow style from body
    useEffect(() => {
        if (isSideMenuActive) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup function to reset overflow when the component unmounts or side menu deactivates
        return () => {
            document.body.style.overflow = '';
        };
    }, [isSideMenuActive]); // Depend on isSideMenuActive to re-run the effect

    useEffect(() => {
        const handleResize = () => {
            if (burgerClicked) {
                setSideMenuValue(window.innerWidth < 1100);
            }
            if (window.innerWidth > 1100) {
                setBurgerClicked(false);
                setSideMenuValue(false);
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [burgerClicked, window.innerWidth]);

    return (
        <Burger
            className={classNames(cls.SideMenuButton, {}, [className])}
            isBurgerActive={isSideMenuActive}
            onClick={() => {
                toggleSideMenu();
                toggleBurgerClicked();
            }}
        />
    );
};
